// src/pages/Home.js
import React, { useRef } from "react";
import { Box } from "@chakra-ui/react";
import HeroSection from "../components/HeroSection";
import PortfolioPreview from "./PortfolioPreview";
import About from "./About";

const Home = () => {
  const portfolioRef = useRef(null);
  const aboutRef = useRef(null);

  const scrollToPortfolio = () => {
    portfolioRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  } 

  return (
    <Box w="100%" minH="100vh" bg="transparent" pt="70px">
      {/* Her kan du sende med begge scroll-funksjoner til HeroSection */}
      <HeroSection onScroll={scrollToPortfolio} onScrollToAbout={scrollToAbout} />
      
      <Box ref={portfolioRef}>
        <PortfolioPreview />
      </Box>
      
      <Box ref={aboutRef}>
        <About />
      </Box>
    </Box>
  );
};

export default Home;